<template>
  <div v-if="hasPermission('has_inline_help')">
    <div class="pl-2">
      [ <a class="caption" @click="showDialog">example</a> ]
    </div>

    <v-dialog
      v-model="enabled"
      @keydown.esc.prevent="closeDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      @input="v => v || closeDialog"
      lazy
      max-width="940px"
      scrollable
    >
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>Hosted Payment Page Link Example</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon flat color="primary" @click.native="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider class="primary"></v-divider>

        <v-card-text>
          <v-card elevation="4">
            <v-card-text>
              <v-layout row wrap align-center justify-center fill-height>
                <v-flex>
                  <v-img max-height="100px" max-width="200px" :src="imageUrl + '/22b32c81-3db3-4906-9f0b-f9c32aec8573.png'"/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-layout row wrap justify-end pa-0>
                    <v-btn color="green" dark depressed>CALL US</v-btn>
                    <v-btn color="purple" dark depressed>BOOK ONLINE</v-btn>
                    <template v-if="environment === 'development'">
                      <v-btn class="btn__pay--active" color="green" dark depressed href="https://payments-dev.paynetworx.com?token=24Yysar1iAeGK8S4fn9L7exozKC" target="_blank">PAY MY BILL</v-btn>
                    </template>
                    <template v-else>
                      <v-btn color="green" dark depressed>PAY MY BILL</v-btn>
                    </template>
                  </v-layout>
                </v-flex>

                <v-flex xs12>
                  <v-toolbar color="purple" dense flat>
                    <v-btn dark flat>HOME</v-btn>
                    <v-btn dark flat>ABOUT PRACTICE</v-btn>
                    <v-btn dark flat>DIAGNOSIS</v-btn>
                    <v-btn dark flat>BLOG</v-btn>
                    <v-btn dark flat>FOR PATIENT</v-btn>
                    <v-btn dark flat>TESTIMONIALS</v-btn>
                    <v-btn dark flat>CONTACT</v-btn>
                  </v-toolbar>
                </v-flex>

              </v-layout>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Bus from '@/bus'

import AuthMixin from '@/mixins/auth'

export default {
  mixins: [AuthMixin],

  data: function () {
    return {
      enabled: false,
      environment: process.env.NODE_ENV,
      imageUrl: process.env.VUE_APP_IMAGE_URL
    }
  },

  beforeDestroy () {
    Bus.$off('closeDialog')
  },

  mounted () {
    Bus.$on('closeDialog', this.closeDialog)
  },

  methods: {
    async showDialog () {
      try {
        this.enabled = true
      } catch (err) {
        Bus.$emit('openDialog', {
          status: 'error',
          message: err
        })
      }
    },

    closeDialog () {
      Bus.$emit('optionsClose')
      this.enabled = false
    }
  }
}
</script>

<style lang="less">
  .btn__pay--active {
    border: 5px solid black;
    padding: 5px;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/help/ExampleHPPLinkSiteDialog.vue